import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ChakraProvider, useToast } from "@chakra-ui/react";
import theme from "./utils/theme/Theme";
import HomeLayout from "./components/layouts/HomeLayout";
import Homepage from "./pages/Homepage";
import Login from "./pages/Login";
import ProductSeller from "./pages/ProductSeller";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
import ScanQris from "./pages/ScanQris";
import BpdVa from "./pages/BpdVa";
import TransactionList from "./pages/TransactionList";
import UserSetting from "./pages/UserSetting";
import NoPage from "./pages/NoPage";
import GeneralContextProvider from "./context/GeneralContext";
import AkunLayout from "./components/layouts/AkunLayout";
import axios from "axios";
import DecryptToken from "./utils/secure/DecryptToken";
import EncryptToken from "./utils/secure/EncryptToken";
import CartLayout from "./components/layouts/CartLayout";

function App() {
  const baseURL = process.env.REACT_APP_BASE_URL;
  const toast = useToast();

  axios.interceptors.response.use(undefined, function (e) {
    if (e.response.status === 406) {
      axios
        .post(baseURL + "/auth/refreshToken", {
          refresh_token: DecryptToken(localStorage.getItem("refresh_token")),
        })
        .then((res) => {
          if (res.status === 200) {
            const result = res.data.data;
            localStorage.setItem("access_token", result.access_token);
            localStorage.setItem(
              "refresh_token",
              EncryptToken(result.refresh_token)
            );
            return;
          }
        })
        .catch((e) => {
          localStorage.removeItem("refresh_token");
          localStorage.removeItem("username");
          localStorage.removeItem("multi_product");
          localStorage.removeItem("access_token");
          window.location.replace("/login");
        });
    }
    if (e.response.status === 500) {
      toast({
        title: "Error 500",
        description:
          "Terjadi kesalahan, mohon reload page atau hubungi administrator",
        status: "warning",
        duration: 9000,
        isClosable: true,
      });
    }
    return Promise.reject(e);
  });

  return (
    <GeneralContextProvider>
      <ChakraProvider theme={theme}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomeLayout />}>
              <Route index element={<Homepage />} />
              <Route path=":keyword" element={<Homepage />} />
              <Route path="perusahaan/:id">
                <Route index element={<ProductSeller />} />
                <Route path="detail/:itemId" element={<ProductDetail />} />
              </Route>

              <Route path="scan-qris" element={<ScanQris />}></Route>
              <Route path="bpd-va" element={<BpdVa />}></Route>

              <Route
                path="daftar-transaksi"
                element={<TransactionList />}
              ></Route>
              <Route path="akun" element={<AkunLayout />}>
                <Route index element={<UserSetting />}></Route>
              </Route>
            </Route>
            <Route path="login" element={<Login />}></Route>
            <Route path="/keranjang" element={<CartLayout />}>
              <Route index element={<Cart />}></Route>
            </Route>
            <Route path="*" element={<HomeLayout />}>
              <Route path="*" element={<NoPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ChakraProvider>
    </GeneralContextProvider>
  );
}

export default App;
